<!-- Layout with two columns for non login-->
<template>
    <v-app id="inspire">
        <Header :hideSlider="true"/>
        <v-main class="grey lighten-3">
            <v-container fluid class="pt-0">
                <!-- row for breadcrumbs on top of page that can be navigated -->
                <v-row>
                    <!-- empty spot so breadcrumbs are above second column -->
                    <v-col cols="12" sm="2"> </v-col>
                    <v-col cols="12" sm="10">
                        <div class="breadcrumb">
                            <ul>
                                <li
                                    v-for="(breadcrumb, index) in crumbs"
                                    :key="index"
                                >
                                    {{ breadcrumb.name }}
                                </li>
                            </ul>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- Left column that shows the current item and possible subpages-->
                    <v-col cols="12" sm="2">
                        <v-sheet rounded="lg" min-height="268">
                            <v-navigation-drawer permanent floating>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ breadcrumbName }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list dense nav>
                                    <v-list-item
                                        v-for="item in items"
                                        :key="item.title"
                                        @click="goTo(item.to)"
                                        link
                                    >
                                        <v-list-item-icon>
                                            <v-icon>{{ item.icon }}</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                item.title
                                            }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-navigation-drawer>
                        </v-sheet>
                    </v-col>
                    <!-- Right column that shows the data of the current page-->
                    <v-col cols="12" sm="10">
                        <v-sheet
                            min-height="calc(100vh - 160px)"
                            min-width="100%"
                            rounded="lg"
                        >
                            <router-view />

                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import Header from "@/components/Header";
import {keycloakMixin} from  "@/mixins/";

export default {
    components: {
        Header,
    },
    mixins: [
    keycloakMixin
  ],
    data() {
        let items = [];

        return {
            items: items,
            breadcrumbName: "Gebruikersinstellingen"
        };
    },
    mounted() {
        this.setNavigationDrawerItems();
    },
    methods: {
        goTo(pathName) {
            if (!pathName || this.$route.name === pathName) {
                return;
            }

            this.$router.push({
                name: pathName
            });
            this.setNavigationDrawerItems();
        },

        /**
         * Set Items shown on the left column for navigation
         * Only show items that belongs to the users role.
         */
        async setNavigationDrawerItems() {

            let items = [];
            items.push(
                {
                    to: "gebruikersgegevens",
                    title: "Mijn gegevens",
                    icon: "mdi-account-circle",
                },
                {
                    to: "inlogbeheer",
                    title: "Beheer inlogmethodes",
                    icon: "mdi-lock",
                },
                {
                    to: "userSSHKeys",
                    title: "SSH Keys",
                    icon: "mdi-key",
                }
            );

            if (this.isDocumentatieinzage()) {
                items.push({
                    to: "documentatie",
                    title: "Documentatie",
                    icon: "mdi-file-multiple",
                });
            }

            this.items = items;
        },
    },
    computed: {
        crumbs: function () {
            //Create a copy so we don't change the route meta permanently
            let breadcrumbCopy = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));

            breadcrumbCopy.forEach((breadcrumb) => {
                breadcrumb.name = "Gebruikersinstellingen / " + breadcrumb.name
            });

            return breadcrumbCopy;
        },
    },
};
</script>

<style lang="scss" scoped>
.border-top {
    border-top: thin solid rgba(0, 0, 0, 0.12);
}
.breadcrumb {
    float: left;
}
ul {
    display: flex;
    justify-content: center;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
ul > li {
    display: flex;
    float: left;
    height: 10px;
    width: auto;
    color: default;
    font-weight: bold;
    font-size: 0.8em;
    cursor: default;
    align-items: center;
}
ul > li:not(:last-child)::after {
    content: "/";
    float: right;
    font-size: 0.8em;
    margin: 0 0.5em;
    color: light-default;
    cursor: default;
}
.linked {
    cursor: pointer;
    font-size: 1em;
    font-weight: normal;
}
.v-list-item__title {
    text-align: left;
    padding-left: 5px;
}
//CSS for list-item topgroups/parents
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 10px;
    margin-left: 5px;
}
//CSS for list-item subgroup/childs
.v-application--is-ltr
    .v-list-group--sub-group
    .v-list-item__action:first-child,
.v-application--is-ltr
    .v-list-group--sub-group
    .v-list-item__avatar:first-child,
.v-application--is-ltr .v-list-group--sub-group .v-list-item__icon:first-child {
    margin-right: 10px;
    margin-left: 0;
}

.nopointer{
    pointer-events: none;
}

.autopointer{
    pointer-events: auto;
}

.v-list-group--sub-group{
    display: block;
}
</style>